<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    preserveAspectRatio="xMinYMin meet"
    class="icon"
  >
    <g>
      <path style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;mix-blend-mode:normal" d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 24 12 L 24 30 L 18 30 L 25 37 L 32 30 L 26 30 L 26 12 L 24 12 z" font-weight="400" font-family="sans-serif" white-space="normal" overflow="visible"/>
    </g>
  </svg>
</template>
<script>
export default {
  name: "arrow-up"
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
